import { shallowEqual, useSelector } from "react-redux";
import get from "lodash/get";

export const useApiData = (key = "", defaultValue = null) => {
  const data = useSelector(
    (state) => get(state, key, defaultValue),
    shallowEqual
  );
  return data;
};
